import React from 'react';
import { ReferenceArrayInput, AutocompleteArrayInput, SelectInput, Filter, List, TextField } from 'react-admin';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

const SitesFilter = (props) => {
    const globalRole = props?.permissions?.role;
    let choices = [
        { id: 'publisher', name: "Publishers" },
        { id: 'site', name: "Sites" }
    ];
    let choicesAdmin = [
        { id: 'publisher', name: "Publishers" },
        { id: 'bidder', name: "Bidders" },
        { id: 'site', name: "Sites" }
    ];
    const getChoices = () => {
        return globalRole==='admin' ? choicesAdmin : choices;
    }
    return (
    <Filter {...props}>
        <SelectInput label="Select View" source="show" alwaysOn choices={getChoices()} />
        {globalRole==='admin' &&
            <ReferenceArrayInput alwaysOn
                source="bidder_id" 
                label="Bidder" 
                reference="bidders"
                basePath="bidders"
                perPage={15} 
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                allowEmpty >
                <AutocompleteArrayInput label="Bidders" optionValue="code"
                optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}  />
            </ReferenceArrayInput>
        }
        <ReferenceArrayInput alwaysOn source="publisher_id" label="Publisher"
            reference="publishers"
            basePath='publishers'
            perPage={10}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
        >
            <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
        </ReferenceArrayInput>
        <SelectInput label="Days" source="days_limit" 
            defaultValue={8}
            choices={[
            { id: 2, name: "2 days" },
            { id: 3, name: "3 days" },
            { id: 5, name: "5 days" },
            { id: 8, name: "8 days" },
            { id: 10, name: "10 days" },
            { id: 15, name: "15 days" },
            { id: 30, name: "30 days" }
        ]} />
        <SelectInput label="Top" source="top" 
            defaultValue={10}
            choices={[
            { id: 5, name: "Top 5" },
            { id: 10, name: "Top 10" },
            { id: 15, name: "Top 15" },
            { id: 20, name: "Top 20" },
            { id: 30, name: "Top 30" },
            { id: 50, name: "Top 50" },
            { id: 100, name: "Top 100" }
        ]} />
        <SelectInput label="Metric" source="metrics" 
            defaultValue="revenue"
            allowEmpty={false}
            choices={[
            { id: 'revenue', name: "$Revenue" },
            { id: 'impressions', name: "Impressions" },
            { id: 'cpm', name: "$CPM" }
        ]} />
        <SelectInput label="Ad Type" source="ad_type" 
            defaultValue="all"
            allowEmpty={false}
            choices={[
            { id: 'banner', name: "Banner" },
            { id: 'video', name: "Video" },
            { id: 'all', name: "ALL" },
        ]} />
    </Filter>
    )
};
const numberCircle = {
  width: '30px',
  lineHeight: '30px',
  borderRadius: '50%',
  textAlign: 'center',
  fontSize: '14px'
}
const SitesListComponent = ({ record }) => {
    let sites = record.sites;
    let index = 1;
    return (
    <table style={{verticalAlign:'top'}}>{
        sites.map(site => { 
            const bgcolor = (site.state==='gone')?'red':(site.state==='up')?'green':(site.state==='down')?'orange':(site.state==='steady')?'blue':(site.state==='new')?'lime':'gray';
            return (
            <tr>
            <td style={{widht:'20px'}}><div style={{...numberCircle, backgroundColor:  bgcolor}}>{site.diff}</div></td>
<td style={{backgroundColor: bgcolor, verticalAlign:'top', padding:'8px', borderRadius:'6px', whiteSpace:'nowrap'}}>
        {(site.site_name)?site.site_name:site.publisher_name}
<br/>
<span style={{fontSize:'x-small'}}>{(site.site_name)?site.publisher_name:""}     
{site.metrics==='cpm' ? 
new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumSignificantDigits: 3 }).format(site.revenue) : 
site.metrics==='impressions' ?new Intl.NumberFormat('en-US', {maximumSignificantDigits: 6 }).format(site.revenue) :
new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumSignificantDigits: 6 }).format(site.revenue)}
</span>
</td>
            </tr>
        )}
    )
    }</table>
    );
};

const TopSitesGrid = ({ ids, data, basePath }) => (
    <span>
    <table style={{textAlign:'center'}}><tr>
    {ids.map(id =>
        <td style={{verticalAlign:'top'}}>
        <Card key={id}>
            <CardHeader
                title={<TextField record={data[id]} source="date" />}
            />
            <CardContent>
                <SitesListComponent record={data[id]}/>
            </CardContent>
        </Card>
        </td>
    )}
    </tr></table>

    <table style={{padding:'10px'}}>
        <tr><td style={{height:'30px'}}><span style={{backgroundColor:'red', paddingLeft:'20px', paddingRight:'20px', paddingTop:'5px', paddingBottom:'1px', borderRadius:'4px'}}></span></td><td><span style={{fontSize: 'small'}}>Dropped from the top chart</span></td>
        <td style={{height:'30px'}}><span style={{backgroundColor:'lime', paddingLeft:'20px', paddingRight:'20px', paddingTop:'5px', paddingBottom:'1px', borderRadius:'4px'}}></span></td><td><span style={{fontSize: 'small'}}>Climbed to the top chart</span></td>
        <td style={{height:'30px'}}><span style={{backgroundColor:'blue', paddingLeft:'20px', paddingRight:'20px', paddingTop:'5px', paddingBottom:'1px', borderRadius:'4px'}}></span></td><td><span style={{fontSize: 'small'}}>Steady, no change</span></td>
        <td style={{height:'30px'}}><span style={{backgroundColor:'green', paddingLeft:'20px', paddingRight:'20px', paddingTop:'5px', paddingBottom:'1px', borderRadius:'4px'}}></span></td><td><span style={{fontSize: 'small'}}>Up</span></td>
        <td style={{height:'30px'}}><span style={{backgroundColor:'orange', paddingLeft:'20px', paddingRight:'20px', paddingTop:'5px', paddingBottom:'1px', borderRadius:'4px'}}></span></td><td><span style={{fontSize: 'small'}}>Down</span></td></tr>
    </table>

    </span>
);

const NoPagination = ({ page, perPage, total, setPage }) => {
    return (
        <span></span>
    );
}

export const TopSitesList = (props) => (
    <List {...props} title="Top Tier" filters={<SitesFilter permissions={props.permissions}/>} pagination={<NoPagination />} exporter={false}>
        <TopSitesGrid />
    </List>
);